import { render, staticRenderFns } from "./GenerateTestPaper.vue?vue&type=template&id=15c45ddf&scoped=true&"
import script from "./GenerateTestPaper.vue?vue&type=script&lang=js&"
export * from "./GenerateTestPaper.vue?vue&type=script&lang=js&"
import style0 from "./GenerateTestPaper.vue?vue&type=style&index=0&id=15c45ddf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c45ddf",
  null
  
)

export default component.exports